import { OrderingFormFields } from '@/components/question/forms/ordering/OrderingForm';
import {
  orderingColumnGenerator,
  orderingItemGenerator,
  orderingQuestionGenerator,
} from '@/data/generators/orderingQuestionGenerator';
import { OrderingItem, OrderingItemCreateDTO } from '@/models/Answer';
import { DNDOrdenationQuestion } from '@/models/Question';
import {
  MediaUrlResolver,
  resolveStringMedia,
} from '@/utils/questions/adapterQuizForm';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export default function adapterOrderingForm(
  ordering: OrderingFormFields,
  resolveMediaUrl: MediaUrlResolver = resolveStringMedia,
): DNDOrdenationQuestion {
  const items = adapterOrderingItems(
    ordering.orderingItems ?? [],
    resolveMediaUrl,
  );

  return orderingQuestionGenerator({
    title: normalizeTranslatableField(ordering.title),
    context: normalizeTranslatableField(ordering.context),
    columns: [orderingColumnGenerator({ flow: ordering.flow, items })],
  });
}

const adapterOrderingItems = (
  items: OrderingItemCreateDTO[],
  resolveMediaUrl: MediaUrlResolver,
): OrderingItem[] =>
  items.map(({ mediaFile, ...item }, index) =>
    orderingItemGenerator({
      ...item,
      id: item.id ?? index,
      order: index + 1,
      dndOrdenationColumn: 1,
      mediaFile: null,
      mediaLink: resolveMediaUrl(mediaFile) ?? item.mediaLink,
    }),
  );
